import { RowAction } from "@/components/tables/ReusableTablePage";
import { Eye } from "lucide-react";

export const getOrderRowActions = (): RowAction[] => [
  {
    label: "View Details",
    icon: Eye,
    onClick: (order: any) => {
      window.open(`/orders/${order.id}`, '_blank');
    },
  },
];